import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const setDefaultCurrencyFunc = createAsyncThunk(
  "setDefaultCurrency",
  async (id, thunkAPI) => {
    try {
      const response = await api.put(`dashboard/currencies/${id}/set-default`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const setDefaultCurrencySlicer = createSlice({
  name: "setDefaultCurrency",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setDefaultCurrencyFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(setDefaultCurrencyFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(setDefaultCurrencyFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default setDefaultCurrencySlicer.reducer;
